/**
 * @generated SignedSource<<d075c261036a5f641d5a210ffb313d0f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type IdentityProviderType = "AWS" | "Azure" | "GCP" | "SAML" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GroupedUsersGridSearchFragment$data = {
  readonly searchUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly apiKeys: {
          readonly pageInfo: {
            readonly total: number | null | undefined;
          };
        };
        readonly email: string | null | undefined;
        readonly identityLinks: ReadonlyArray<{
          readonly provider: {
            readonly idpNamespace: string;
          };
        }>;
        readonly key: number;
        readonly lastLogin: string | null | undefined;
        readonly name: string | null | undefined;
        readonly roleAssignments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly role: {
                readonly name: string;
                readonly system: boolean;
              };
            };
          }> | null | undefined;
        };
        readonly userGroups: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string | null | undefined;
              readonly id: string;
              readonly name: string;
              readonly source: {
                readonly idpAlias: string | null | undefined;
                readonly idpNamespace: string;
                readonly idpType: IdentityProviderType;
              } | null | undefined;
              readonly uuid: any;
            };
          }> | null | undefined;
        };
      };
    }>;
    readonly pageInfo: {
      readonly total: number | null | undefined;
    };
  };
  readonly " $fragmentType": "GroupedUsersGridSearchFragment";
};
export type GroupedUsersGridSearchFragment$key = {
  readonly " $data"?: GroupedUsersGridSearchFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupedUsersGridSearchFragment">;
};

import GroupedUsersGridSearchRefetchQuery_graphql from './GroupedUsersGridSearchRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpNamespace",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": GroupedUsersGridSearchRefetchQuery_graphql
    }
  },
  "name": "GroupedUsersGridSearchFragment",
  "selections": [
    {
      "alias": "searchUsers",
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filter"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "users",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "APIKeyConnection",
                  "kind": "LinkedField",
                  "name": "apiKeys",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserIdentityLink",
                  "kind": "LinkedField",
                  "name": "identityLinks",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "provider",
                      "plural": false,
                      "selections": [
                        (v1/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastLogin",
                  "storageKey": null
                },
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": (v3/*:: as any*/),
                  "concreteType": "UserGroupConnection",
                  "kind": "LinkedField",
                  "name": "userGroups",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UserGroupEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "UserGroup",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "displayName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "id",
                              "storageKey": null
                            },
                            (v2/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "source",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "idpAlias",
                                  "storageKey": null
                                },
                                (v1/*:: as any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "idpType",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "uuid",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "userGroups(first:100)"
                },
                {
                  "alias": null,
                  "args": (v3/*:: as any*/),
                  "concreteType": "RoleAssignmentConnection",
                  "kind": "LinkedField",
                  "name": "roleAssignments",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoleAssignmentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RoleAssignment",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Role",
                              "kind": "LinkedField",
                              "name": "role",
                              "plural": false,
                              "selections": [
                                (v2/*:: as any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "system",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "roleAssignments(first:100)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v0/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "9b539c0b74e56d024d8a5092e9a0d437";

export default node;
